import { createSlice } from "@reduxjs/toolkit";

const tourSlice = createSlice({
  name: "tour",
  initialState: {
    tourList: [],
    randomList: [],
    isFetching: false,
    isFetchingAll: false,
    isLoggedIn: false,
    error: false,
    totalPage: 0,
    totalItem: 0,
  },
  reducers: {
    getTour: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getTourSuccess: (state, action) => {
      state.isFetching = false;
      state.tourList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getTourFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getTourRandom: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getTourRandomSuccess: (state, action) => {
      state.isFetching = false;
      state.randomList = action.payload.data
      state.error = false;
    },
    getTourRandomFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    addTour: (state) => {
      state.isFetching = true
      state.error = false
    },
    addTourSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    addTourFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    updateTour: (state) => {
      state.isFetching = true
      state.error = false
    },
    updateTourSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    updateTourFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    removeTour: (state) => {
      state.isFetching = true
      state.error = false
    },
    removeTourSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    removeTourFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
  },
});

export const tourActions = tourSlice.actions;
export default tourSlice.reducer;
